﻿import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {UIGameObject} from "../Tools/Base/UIGameObject";
import {UIText} from "../Tools/Base/UIText";
import {Time} from "../../Utils/Unity/Time";
import {NUtils} from "../../Utils/NUtils";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {Core} from "../../Base/Core";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UISprite} from "../Tools/Base/UISprite";

const OFFER_TIMEOUT = 3600 * 1000; // ms

export class UIFirstCreatureOffer extends UICommonPopup {
    get RequestedCreatureId() {
        return PlayerPrefs.GetInt("sjdhfn84ew7yfn7800000", 0);
    }

    set RequestedCreatureId(value) {
        PlayerPrefs.SetInt("sjdhfn84ew7yfn7800000", value);
    }

    get epochId() {
        let creatureId = this.RequestedCreatureId;
        let epochData = Core.GameData.Epochs.GetByCreatureId(creatureId);
        return epochData ? epochData.id : undefined;
    }

    set epochId(value) {
        let epochData = Core.GameData.Epochs.GetById(value);
        this.RequestedCreatureId = epochData ? epochData.creatures[0] : 0;
    }

    get planetId() {
        let epochId = this.epochId;
        for (let planet of Core.Player.PlanetsSave.planets) {
            if (planet.epochs.includes(epochId)) return planet.planetId;
        }
        return 0;
    }

    get available() {
        return Core.Store.ProductAvailable("first_creature_offer_1") || Core.Store.ProductAvailable("first_creature_offer_2");
    }

    get offerEndTime() {
        if (!this.available) return 0;
        if (!this.RequestedCreatureId) return 0;
        if (!Core.Player.Timers.firstCreatureOfferTime) return 0;
        return Core.Player.Timers.firstCreatureOfferTime + OFFER_TIMEOUT;
    }

    get offerTimeLeft() {
        let endTime = this.offerEndTime;
        if (!endTime) return 0;
        let diff = endTime ? endTime - Core.Time.serverTime : 0;
        return Math.max(0, diff);
    }

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("offer_firstcreature_title"),
            closeButton: true,
            skin: "magenta",
        });

        this.onProductPurchased = this.onProductPurchased.bind(this);

        this.timerField = this.content.addChild(new UIText("", { fitTextTemplate: "00h 00m 00s" }));
        this.timerContainer = this.content.addChild(new UIGameObject());
        this.creaturesImgs = [];
        this.purchaseBtn = this.content.addChild(new UINineSliceButton("btn-orange", { label: "" }));
        this.creatureNameFld = this.content.addChild(new UIText());
        this.multiplierFld = this.content.addChild(new UIText("X6"));
        for (let i = 0; i < 6; i++) {
            this.creaturesImgs.push(this.content.addChild(new UISprite()));
        }
        this.lastUpdateTime = 0;

        Core.Store.on("Purchased", this.onProductPurchased);
    }

    Init() {
        if (!this.available) return;
        super.Init();

        let productId = Core.Store.ProductAvailable("first_creature_offer_1", true) ? "first_creature_offer_1" : "first_creature_offer_2";
        this.purchaseBtn.label = Core.Store.GetPrice(productId);
        this.purchaseBtn.off("pointertap");
        this.purchaseBtn.on("pointertap", () => {
            Core.Store.BuyProductID(productId);
        });
    }

    _fitCreatures(parentRect) {
        if (!this.creaturesImgs.length) return;

        let yStep = parentRect.height * 0.15;

        let tx = this.creaturesImgs[0].texture;
        let k = (parentRect.height - yStep * 2) / tx.height;
        let rect = new PIXI.Rectangle(0, 0, tx.width * k, tx.height * k);
        let xStep = rect.width - (rect.width * this.creaturesImgs.length - parentRect.width) / (this.creaturesImgs.length - 1);

        rect.x = parentRect.x + xStep * 3;
        rect.y = parentRect.y + yStep * 2;
        this.creaturesImgs[5].fitRect(rect);
        this.creaturesImgs[3].tint = 0xffffff;

        rect.x = parentRect.x + xStep * 2;
        rect.y = parentRect.y + yStep * 2;
        this.creaturesImgs[4].fitRect(rect);
        this.creaturesImgs[3].tint = 0xffffff;

        rect.x = parentRect.x + xStep * 4;
        rect.y = parentRect.y + yStep * 1;
        this.creaturesImgs[3].fitRect(rect);
        this.creaturesImgs[3].tint = 0x999999;

        rect.x = parentRect.x + xStep * 1;
        rect.y = parentRect.y + yStep * 1;
        this.creaturesImgs[2].fitRect(rect);
        this.creaturesImgs[2].tint = 0x999999;

        rect.x = parentRect.x + xStep * 0;
        rect.y = parentRect.y + yStep * 0;
        this.creaturesImgs[1].fitRect(rect);
        this.creaturesImgs[1].tint = 0x666666;

        rect.x = parentRect.x + xStep * 5;
        rect.y = parentRect.y + yStep * 0;
        this.creaturesImgs[0].fitRect(rect);
        this.creaturesImgs[0].tint = 0x666666;
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.6;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.95;
        rect.height = contentRect.height * 0.3;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.32;
        this._fitCreatures(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.5;
        rect.height = contentRect.height * 0.05;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.17;
        this.timerField.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.7;
        rect.height = contentRect.height * 0.06;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.65;
        this.creatureNameFld.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.5;
        rect.height = contentRect.height * 0.1;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.75;
        this.multiplierFld.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.45;
        rect.height = contentRect.height * 0.14;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.purchaseBtn.fitLayout(rect);
    }

    onProductPurchased(product) {
        if (product.id == "first_creature_offer_1" || product.id == "first_creature_offer_2") {
            this.Hide();
        }
    }

    Show(creatureId = this.RequestedCreatureId) {
        if (!this.available) return;
        if (creatureId) {
            this.RequestedCreatureId = creatureId;
        }

        if (!Core.Store.IsInitialized) return;
        if (!Core.Player.Initialized) return;
        if (!Core.Time.Initialized) return;
        if (!this.RequestedCreatureId) return;
        if (!Core.Player.Timers.firstCreatureOfferTime) return;
        this.Init();

        let creature = Core.GameData.Creatures.Get(this.RequestedCreatureId);
        for (let img of this.creaturesImgs) {
            img.setImage(`creatures/${creature.id}`);
        }

        this.creatureNameFld.text = Core.Localizator.Get(creature.creatureName);

        if (this.offerTimeLeft > 0) {
            super.Show();
            this.updateTime();
        }
    }

    Update() {
        if (!this.available) return;
        this.lastUpdateTime += Time.deltaTime;
        if (this.lastUpdateTime > 1) {
            this.updateTime();
            this.lastUpdateTime = 0;
        }
        if (!Core.Player.Timers.firstCreatureOfferTime) {
            this.Hide();
        }
    }

    updateTime() {
        let timeLeft = this.offerTimeLeft;
        this.timerField.text = NUtils.FormatSecondsToTime(timeLeft / 1000);
        if (timeLeft <= 0) {
            this.Hide();
        }
    }
}
